/**
 * @file
 * Block list JS.
*/
(function ($, Drupal, drupalSettings) {

  'use strict';

  // Globally available variables/settings
  Drupal.videoCardsCarousel = function() {
    var $slider = jQuery('.field--name-field-video-cards');
    if (window.innerWidth < 992 && !$slider.hasClass('slick-initialized')) {
      $slider.slick({
        dots: true,
        infinite: true,
        arrows: false,
        slidesToShow: 1,
      }).addClass('slick');
    } else if (window.innerWidth > 993 && $slider.hasClass('slick-initialized')) {
      $slider.slick('unslick').removeClass('slick');
    }
  }

  /**
   * Convert block list (links) to carousel at mobile.
   */
  Drupal.behaviors.videoCardsCarousel = {
    attach: function(context, settings) {
      $(once('videoCardsCarousel', '.field--name-field-video-cards')).each(function() {  
        Drupal.videoCardsCarousel();
        $(window).resize(Drupal.videoCardsCarousel);
      });
    }
  }

})(jQuery, Drupal, drupalSettings);